import React, {Component} from 'react'
import {Dialog} from 'primereact/dialog';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import {InputText} from 'primereact/inputtext';
import {InputMask} from 'primereact/inputmask';

import ObraCard from '@/components/obra/ObraCard';
import { Col, Row, FormGroup } from 'reactstrap'
import {Chart} from 'primereact/chart';
import { withRouter } from 'react-router-dom'
import { Consumer  as ObraConsumer} from '@/views/obras/context/ObraContext'
import {ApplicationContextConsumer} from '@/app/context/AppContext'
import {Messages} from 'primereact/messages';

import './consultaObras.css'

@withRouter
class ConsultaObras extends Component {
        
    state = {
        showLoad: false,
        showEmptyListMessageDialog: false,
        municipios: []  
    }

    async componentDidMount(){
        await this.props.listarMunicipios()
        let municipios = [{ descricao: "TODO O CEARÁ" }].concat(this.props.municipios)
        this.setState({municipios})
    }

    validaConsulta = () => {
        return this.props.municipioSelecionado || this.props.inep || this.props.descricaoUnidadeTrabalho;
    }

    consultar = async () => {
        if(!this.validaConsulta()){
            this.messages.show({
                severity: 'error', 
                detail: 'Preencha pelo menos um dos campos de Consulta.', 
                closable: false
            });
        }else{
            this.props.showLoad(true)
            await this.props.consultarObras();
            this.setState({ showEmptyListMessageDialog: this.props.noResult })
            this.props.showLoad(false)
        }
    }

    filtarPorStatus = (event) => {
        this.props.showLoad(true)
        this.props.filtarPorStatus(event)
        this.props.showLoad(false)
    }

    visualizarDetalhesProcesso = (orcamento) => {
        this.props.history.push(`/obras/${orcamento}`)
    }

    render(){
        const Obras = () => ( this.props.obras || [] ).map( obra => 
            <div key={obra.numeroOrcamento}>
                <ObraCard onClick={ e => this.visualizarDetalhesProcesso(obra.numeroOrcamento)} width="400px" obra={obra} />
            </div>  
        )

        const emptyListMessageDialogFooter = (
            <div>
                <Button label="Ok" 
                        icon="pi pi-check" 
                        className="p-button-success" 
                        onClick={() => this.setState({ showEmptyListMessageDialog: false })} />
            </div>
        );
        
        const chartOptions = {
            title: {
                display: true,
                text: this.props.mensagemResultadoConsulta,
                fontSize: 14
            },
            legend: {
                display: false
            }
        }

        const {inep , descricaoUnidadeTrabalho, municipioSelecionado, renderSituacaoFiltro, situacaoSelecionada, situacoes, graficoData, renderGrafico} = this.props
 
        return (
            <div className="card">

                <div className="card-body">
                    <h4 className="font-weight-bold mt-4">
                        <span>Consulta Obras</span>
                        <hr className="my-4" />
                    </h4>

                    <Row>
                        <Col md={6}>
                            <Row>
                                <Col md={12}>
                                    <Messages ref={(el) => this.messages = el}  />
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <label htmlFor="inputMunicipio">Município: </label>
                                        <Dropdown  id="inputMunicipio"
                                                className="full"
                                                key="id"
                                                optionLabel="descricao" 
                                                style={{width: '100%'}}
                                                required={true}
                                                disabled={renderSituacaoFiltro}
                                                filter={true}
                                                showClear={false}
                                                value={municipioSelecionado} 
                                                options={this.state.municipios} 
                                                onChange={e => this.props.onMunicipioChange(e)} 
                                                placeholder="Selecione" />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={3}>
                                    <FormGroup>
                                        <label htmlFor="inputInep">Inep: </label>
                                        <InputMask id="inputInep" 
                                                   autoClear={false} 
                                                   slotChar={""}
                                                   className={"form-control"} 
                                                   mask="99999999"
                                                   name="inep"
                                                   value={inep || ""} 
                                                   onChange={e => this.props.onInputChange(e)} />
                                    </FormGroup>
                                </Col>
                                <Col md={9}>
                                    <FormGroup>
                                        <label htmlFor="inputUnidadeTrab">Escola</label>
                                        <InputText id="inputUnidadeTrab" 
                                                   className={"form-control"} 
                                                   name="descricaoUnidadeTrabalho" 
                                                   value={descricaoUnidadeTrabalho || ""} 
                                                   onChange={e => this.props.onInputChange(e)} />
                                    </FormGroup>                                    
                                </Col>
                            </Row>

                            { this.props.renderSituacaoFiltro && 
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <label htmlFor="inputSituacao">
                                                Situação:
                                            </label>
                                            <Dropdown   id="inputSituacao"
                                                        className="full"
                                                        key="index"
                                                        optionLabel="descricao" 
                                                        style={{
                                                            width: '100%'
                                                        }}
                                                        filter={true}
                                                        showClear={false}
                                                        value={situacaoSelecionada} 
                                                        options={situacoes} 
                                                        onChange={e => this.filtarPorStatus(e) }
                                                        placeholder="Selecione" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            } 

                            <Row>
                                <Col md={12}>
                                    <Button label="Consultar" onClick={e => this.consultar() } icon="pi pi-search" className="p-btn p-button-success mr-2" />
                                    <Button label="Limpar" onClick={e => this.props.limparConsulta()} icon="pi pi-times" className="p-btn p-button-secondary" />
                                </Col>
                            </Row>
                        </Col>

                        {/** coluna que aparece o gráfico */}
                        <Col md={6}>
                            <Row>
                                <Col md={12}>
                                { renderGrafico && 
                                    <Chart height="120" 
                                           type="bar" 
                                           options={chartOptions}
                                           data={graficoData} />
                                }
                                </Col>
                            </Row>
                        </Col>
                        
                    </Row>                   
                    <hr />
                    <Obras />

                    <Dialog header="Atenção!" 
                            visible={this.state.showEmptyListMessageDialog} 
                            style={{width: '200px'}} 
                            modal={true} 
                            footer={emptyListMessageDialogFooter}
                            onHide={(e) => this.setState({showEmptyListMessageDialog: false})}>
                            Nenhum Registro de Obra encontrada para os filtros informados.
                    </Dialog>
          
                </div>
            </div>
        )
    }
}


export default () => (
    <ApplicationContextConsumer>
        {(appContext) => (
            <ObraConsumer>
                {(ctx) => (
                    <ConsultaObras {...ctx} showLoad={appContext.showLoad} />
                )}
            </ObraConsumer>
        )}       
    </ApplicationContextConsumer>
)